import { render, staticRenderFns } from "./BeneficiariosListado.vue?vue&type=template&id=4274de00"
import script from "./BeneficiariosListado.vue?vue&type=script&lang=js"
export * from "./BeneficiariosListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports